import React, { useState } from 'react';
import { __ } from '@wordpress/i18n';

// components
import ToggleSwitch from '../../../../../../components/ToggleSwitch';
import ButtonOutline from '../../../../../../components/ButtonWrapper/components/ButtonOutline';

const TopBarLeftControls = () => {
    // Not persisted yet — no API for the bootcamp updates preference
    const [bootcampUpdates, setBootcampUpdates] = useState(false);

    return (
        <div className="topBarLeftControls">
            <span className="topBarLeftControls__label">
                {__('Bootcamp Updates', 'soundbetween')}
            </span>
            <ToggleSwitch
                name="bootcampUpdates"
                checked={bootcampUpdates}
                ariaLabel={__('Bootcamp Updates', 'soundbetween')}
                changeFn={(checked) => setBootcampUpdates(checked)}
            />
            <ButtonOutline onClick={() => {}}>
                {__('Change user', 'soundbetween')}
            </ButtonOutline>
        </div>
    )
}

export default TopBarLeftControls;
